<script lang="ts" setup>
import { twMerge } from "tailwind-merge";
import type { HTMLAttributes } from "vue";

const props = defineProps<{
	class?: HTMLAttributes["class"];
}>();
</script>

<template>
	<ol
		:class="twMerge(
			'flex flex-nowrap items-center gap-1.5 break-words text-sm text-muted-foreground lg:gap-2.5 whitespace-nowrap',
			props.class,
		)"
	>
		<slot />
	</ol>
</template>
